import { InjectionToken } from '@angular/core';

export interface GridConfig {
    gridType: 'antd' | 'ag-grid';
}

export const GRID_CONFIG = new InjectionToken<GridConfig>('GRID_CONFIG');
